/** Minúscules i sense diacrítics ("Préssec" -> "pressec") per a cerques insensibles a accents. */
export function foldText(s: string): string {
  return s
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}
